import { render, staticRenderFns } from "./app.vue?vue&type=template&id=568381ac"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports